import React from 'react';

import { Box, Card, Flex, Space, Text, Title, useMantineTheme } from '@mantine/core';
import bgImage from 'assets/images/bg.png';
import { UpgradePlanButton } from 'components/UpgradePlanButton';
import { useTranslation } from 'react-i18next';

interface UpgradePlanBlurCardProps {
  title?: string;
  message: string;
  showCard: boolean;
  children?: React.ReactNode;
  scale?: number;
  cardWidth?: number;
  cardHeight?: number;
}

export function UpgradePlanBlurCard({
  title,
  message,
  children,
  showCard,
  scale = 1,
  cardWidth = 325,
  cardHeight = 160
}: UpgradePlanBlurCardProps) {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <Box h="100%" w="100%" sx={{ position: 'relative' }}>
      <Flex
        direction="column"
        h="100%"
        sx={{ filter: showCard ? 'blur(3px)' : '', pointerEvents: showCard ? 'none' : 'auto' }}>
        {children}
      </Flex>
      {showCard && (
        <Box
          sx={{
            position: 'absolute',
            top: `calc(50% - ${cardHeight / 2}px)`,
            left: `calc(50% - ${cardWidth / 2}px)`,
            transform: `scale(${scale})`
          }}>
          <Card
            withBorder
            w={cardWidth}
            mih={cardHeight}
            sx={{
              backgroundImage: `url(${bgImage})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',

              backgroundPosition: 'center'
            }}>
            <Flex align="center" direction="column" h="100%">
              <Title order={3} align="center">
                {title ?? t('APP.UNLOCK_PREMIUM_FEATURE')}
              </Title>
              <Space h="xs" />
              <Text maw={cardWidth * 0.8} align="center" c={theme.other.text.dimmed}>
                {message}
              </Text>
              <Space h="sm" />
              <UpgradePlanButton showLogo />
            </Flex>
          </Card>
        </Box>
      )}
    </Box>
  );
}
